import * as React from 'react';
import { Icon } from '../../primitives/icon/icon';
/* tslint:disable */
export var smallToggleArrowIcon = "\n<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"25\" height=\"25\" viewBox=\"0 0 25 25\">\n<path fill-rule=\"evenodd\" d=\"M16.202 12.98l.028.027-4.863 4.864-1.365-1.363 3.543-3.544L10 9.418 11.418 8l4.88 4.882-.096.097z\"/>\n</svg>\n";
export var SmallToggleArrowIcon = function () { return React.createElement(Icon, { icon: smallToggleArrowIcon }); };
//# sourceMappingURL=small-toggle-arrow.js.map